export const paths = [{ "tag": "path", "att": { "d": "M12 22H3V2h9v2H5v16h7v2z" } }, { "tag": "path", "att": { "d": "m16.1715 11-3.2429-3.243 1.4142-1.4142 5.6568 5.6568-5.6568 5.6569-1.4142-1.4142L16.1708 13H7.9999v-2h8.1716z" } }];
export const iconName = 'arrow-right-from-base';
export const arrowRightFromBase = { iconName, paths };
export default paths;
